import { styled } from "@mui/material";

export const Row = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "row nowrap",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: theme.spacing(1),
}));
